import { combineReducers } from 'redux';

import curriculum from './reducers/curriculumReducer';
import round from './reducers/roundReducer';
import reporting from './reducers/reportingReducer';

/**
 * Keeping the reducer collection as a separate exported object enables us
 * to do some light test automation on every reducer.
 * @see ./reducers/__tests__/reducerRejections.test.js
 */
const reducers = {
  curriculum,
  round,
  reporting,
};

export default combineReducers(reducers);
